import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Kommissionierung } from '../../types/kommissionierung';

import { DateInputComponent } from '@softline/ui-core/date-input';
import { InputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-warenzugang-buchen',
  imports: [FormsModule, ReactiveFormsModule,
    DateInputComponent,
    InputComponent,
    TranslatePipe],
  templateUrl: './warenzugang-buchen.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./warenzugang-buchen.css'] })
export class WarenzugangBuchenComponent {
  public _kommissionierung!: Kommissionierung;
  public _eingabeLieferscheinnummerPflicht = false;

  public form: FormGroup = new FormGroup({
    bezugsdatum: new FormControl(this._kommissionierung?.bezugsdatum ?? '', [
      Validators.required]),
    lieferscheinnummer: new FormControl(this._kommissionierung?.bezugsnummer ?? '', [
      Validators.required]) });
  @Input()
  set kommissionierung(kommissionierung: Kommissionierung) {
    this._kommissionierung = kommissionierung;
  }
  @Input()
  set eingabeLieferscheinnummerPflicht(eingabeLieferscheinnummerPflicht: boolean) {
    this._eingabeLieferscheinnummerPflicht = eingabeLieferscheinnummerPflicht;
    if (this._eingabeLieferscheinnummerPflicht) {
      this.lieferscheinnummerValid$.next(false);
    } else {
      this.lieferscheinnummerValid$.next(true);
    }
  }

  @Output('warenzugangBuchenClicked')
  kommissionierungFuerAbschluss: EventEmitter<Kommissionierung> =
    new EventEmitter<Kommissionierung>();

  readonly lieferscheinnummerValid$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(true);

  updateBelegdatumLocal(bezugsdatum: string) {
    if (!bezugsdatum || !this._kommissionierung) return;

    this._kommissionierung.bezugsdatum = bezugsdatum;
  }

  updateLieferscheinnummerLocal(lieferscheinnummer: string) {
    if (lieferscheinnummer.length <= 0) {
      this.lieferscheinnummerValid$.next(false);
      return;
    }
    this.lieferscheinnummerValid$.next(true);

    if (!this._kommissionierung) return;

    this._kommissionierung.bezugsnummer = lieferscheinnummer + '';
  }

  async emitWarenzugangBuchen() {
    this.kommissionierungFuerAbschluss?.emit(this._kommissionierung);
  }
}
